import { deleteLineItem } from "@lib/data/cart"
import { notifyCartChanged } from "@lib/context/cart-context"
import { useTracking } from "@lib/analytics/tracking-context"
import type { GtmItem } from "@lib/analytics/gtm"
import { Spinner, Trash } from "@medusajs/icons"
import { clx } from "@modules/common/components/ui"
import { useState } from "react"

const DeleteButton = ({
  id,
  children,
  className,
  trackingItem,
}: {
  id: string
  children?: React.ReactNode
  className?: string
  // Optional analytics payload — when present, fire remove_from_cart. Keeps this
  // shared primitive decoupled from cart-specific data (plan §D4).
  trackingItem?: GtmItem
}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const { trackRemoveFromCart } = useTracking()

  const handleDelete = async (id: string) => {
    setIsDeleting(true)
    await deleteLineItem(id)
      .then(() => {
        if (trackingItem) trackRemoveFromCart(trackingItem)
        notifyCartChanged()
      })
      .catch((_err) => {
        setIsDeleting(false)
      })
  }

  return (
    <div
      className={clx(
        "flex items-center justify-between text-small-regular",
        className
      )}
    >
      <button
        className="flex gap-x-1 text-ui-fg-subtle hover:text-ui-fg-base cursor-pointer"
        onClick={() => handleDelete(id)}
      >
        {isDeleting ? <Spinner className="animate-spin" /> : <Trash />}
        <span>{children}</span>
      </button>
    </div>
  )
}

export default DeleteButton
